import { render, staticRenderFns } from "./sfc-youtube.vue?vue&type=template&id=0893abc8&scoped=true&lang=pug&"
import script from "./sfc-youtube.vue?vue&type=script&lang=js&"
export * from "./sfc-youtube.vue?vue&type=script&lang=js&"
import style0 from "./sfc-youtube.vue?vue&type=style&index=0&id=0893abc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893abc8",
  null
  
)

export default component.exports